import { AdminRO } from '@routellers/types/dist/admin/admin.ro';
import { UpdateAdminDto } from '@routellers/types/dist/admin/create-admin.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    id: number;
    data: UpdateAdminDto;
};

type ResponseData = AdminRO;

export const update: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, data }) => ({
    url: `/admins/${id}`,
    method: 'PATCH',
    data,
});
